<template>
  <div class="dynamic-product-simple scene-wrap" v-if="data && data._isScene">
    <div class="scene-img" style="height: 100%;" @click="jump">
      <video
        v-if="data.sceneVideo"
        webkit-playsinline="true"
        playsinline="true" 
        :poster="data.sceneCover"
        :src="data.sceneVideo"  
        :autoplay="true"
        :controls="false"
        :muted="true"
        style="height: 100%;width: 100%;object-fit: cover;"
      />
      <img
        v-else
        :lazy="true"
        :src="data.sceneImage || data.sceneCover"
      />
    </div>
    <div class="line-btm"></div>
    <div class="line-rt" v-if="index % 2 != 1"></div>
  </div>
  <div class="dynamic-product-simple" v-else>
    <div v-if="productImage" class="product-image" @click="jump">
      <beast-image
        :lazy="true"
        :defaultImage="defaultImage"
        :src="productImage"
      />
      <div class="image-state">
        <div class="corner-boxs" v-if="data.foretell">
          <div class="stats-tag" style="border: solid 0.8px #ABACAD; color:#ABACAD; line-height: 1.8;">
            <span>即将开售</span>
          </div>
        </div>
        <div class="corner-boxs" v-if="data.offShelf">
          <div class="stats-tag" style="border: solid 0.8px #ABACAD; color:#ABACAD; line-height: 1.8;">
            <span>下架</span>
          </div>
        </div>
        <div class="corner-boxs" v-else-if="data.soldOut">
          <div class="stats-tag" style="border: solid 0.7px #ABACAD; color:#ABACAD; line-height: 1.8;background-color: #F1F2F4;">
            <span>售罄</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="product-image">
      <img :src="defaultImage" />
    </div>
    <div class="product-infos" @click="jump">
      <div class="summary"
        :style="{
          'display':data._showSummary ? 'none':'block'
        }"
        :class="{
          'normal':data.copywriter && data.copywriter.type !== 'NORMAL',
          'hidden':!data.copywriter
        }"
      >{{data.copywriter && data.copywriter.textContent || '1'}}</div>
      <!-- <div
        class="brand-name gro-book"
        v-if="productCondition.brandName === 'SHOW' && data.brand" 
      >{{data.brand && data.brand.name}}</div> -->
      <div
        class="name" 
      >{{data.name}}</div>
      <div class="prices newn" v-if="data.mainStationFirst">
        <div class="price discount-price"><span class="newn-tag">首单价</span><price :data="data.price"/></div>
        <div class="price raw-price" v-if="data.price < data.rawPrice"><price :data="data.rawPrice" /></div>
      </div>
      <div class="prices" :class="{'rush-color': data.rush}" v-else-if="!data.newcomerTag">
        <div class="price discount-price"><price :data="data.price"/></div>
        <div class="price raw-price" v-if="data.price < data.rawPrice"><price :data="data.rawPrice"/></div>
      </div>
      <div class="prices newn" v-else>
        <div class="price discount-price"><span class="newn-tag">新人价</span><price :data="data.price"/></div>
        <div class="price raw-price" v-if="data.price < data.rawPrice"><price :data="data.rawPrice"/></div>
      </div>
      <!-- <div class="price-box">
        <div
          class="prices"
        >
          <div class="price discount-price gro-demi"> <price v-if="data.price" :data="data.price" /><span v-if="data.newcomerTag && !data.mainStationFirst" class="newn-tag">新人价</span><span v-if="data.mainStationFirst" class="newn-tag-shoudan">首单价</span></div>
          <del class="price raw-price grotesk" v-if="data.price < data.rawPrice"><price v-if="data.rawPrice" :data="data.rawPrice"/></del>
        </div>
        <div class="stock-warn" v-if="data.stockWarn">{{data.stockWarn || ''}}</div>
      </div> -->
      <div class="refund-box" v-if="data.refunds">
        <div class="refund">约返{{data.refunds | formatPrice}}元</div>
      </div>
    </div>
    <div class="support" v-if="data.deliveryTag === '01' || data.deliveryTag === '03'"><div class="m">该区域不支持</div></div>
    <div class="support" v-if="data.deliveryTag === '02'">
      <div class="m">该时间不支持</div>
      <div class="m-line"></div>
      <div class="t" @click="getDate(data)">查看可选时间</div>
    </div>
    <div class="tag" v-if="data.customizable">可定制</div>
    <div class="tag" v-else-if="data.isOversea">跨境商品</div>
    <div class="line-btm"></div>
    <div class="line-rt" v-if="index % 2 != 1"></div>
    <!-- <div class="refund" v-if="data.refunds">约返{{data.refunds | formatPrice}}元</div> -->
  </div>
</template>

<script>
  import price from '@/price'
  import beastImage from '@/components/image'
  import track from '@/track'
  import { lazyload } from '@/lazyload'
  import browser from '@beastshop/browser'
  import beastVideo from '@/components/video'
  import { ensure_protocol } from '@beastshop/url-util'
  import { transformLink, trackSkip } from '@/link'
  // import data from '../../activity/big-furniture/data';

  const defaultImage = ensure_protocol("http://img.thebeastshop.com/app/5.0/images/default-list.png")
  const cornerImg = {
    foretell: ensure_protocol("http://img.thebeastshop.com/app/list/foretell.png"),
    offshelf: ensure_protocol("http://img.thebeastshop.com/app/list/offshelf.png"),
    soldout: ensure_protocol("http://img.thebeastshop.com/app/list/soldout.png")
  }


  export default {
    name: 'list-v1',

    props: {
      data: {
        require: true
      },
      index: {
        type: Number,
        default: 0
      },
      env: {
        default:'m-web'
      }
    },

    data: function () {
      return {
        defaultImage: defaultImage,
        productData: this.data,
        cornerImg: cornerImg
      }
    },

    components: {
      price,
      beastImage,
      beastVideo
    },

    mounted () {
      lazyload()
    },

    watch: {
      data (d) {
        if (typeof d === 'object') {
          // this.fit()
        }
      }
    },

    filters: {
      formatPrice (value) {
        let v = String(Math.floor(value*Math.pow(10,1)) / Math.pow(10,1))
        const temp = v.split('.')
        return temp.length > 1 
          ? v
          : `${v}.0`
      }
    },

    computed: {
      productImage () {
        const data = this.data

        return data.cropListImage || data.cropFeatureImage || data.featureImage
      }
    },
    methods: {
      jump (e) {
        // const tar = e.currentTarget
        // const pindex = tar.dataset.index
        const pindex = this.index
        console.log(pindex, '#########index')

        if(!this.data || !this.data.id) {
          return
        }

        this.$emit('product-simple', this.data, pindex)

        const link = transformLink({
          link: {
            type: "product",
            value: this.data.id
          },
          isMini: this.env == 'miniprogram'
        })

        const trackData = {
          trackData: {
            name: this.source === 'CART' ? 'cart-suggest-product-more' : 'click-result',
            attrs: {
              value: this.data.id,
              index: pindex
            }
          },
          link,
          isMini: this.env == 'miniprogram'
        }

        trackSkip(trackData)
      },

      getDate (item) {
        this.$emit('dateGet', item)
      },

      fit () {
        const tagItem = document.querySelectorAll('.prices')
        const tagArr = Array.from(tagItem)
        tagArr.forEach(elem => {
          const discount = elem.querySelector('.discount-price')
          const rawcount = elem.querySelector('.raw-price')
          const tags = elem.querySelector('.tags-wrap')

          const dw = discount && discount.clientWidth || 0
          const rw = rawcount ? rawcount.clientWidth : 0
          const tw = tags && tags.clientWidth || 0

          if ((dw + rw + tw) > elem.clientWidth) {
            tags.style.display = 'none'
          }
        })
      }
    }
  }


</script>

<style scoped lang="stylus">
@import '../../common/styl/global.styl'
@font-face {
  font-family: "ECBR";  /* 这里的字体名称是自定义的 */
  src: url("https://img.thebeastshop.com/app/5.0/fonts/EuclidCircularBRegular.ttf") format('opentype'); /* 服务器上ttf文件的路径，记得配置域名权限 */
}
@font-face {
  font-family: "ECBM";  /* 这里的字体名称是自定义的 */
  src: url("https://img.thebeastshop.com/app/5.0/fonts/EuclidCircularBMedium.ttf") format('opentype'); /* 服务器上ttf文件的路径，记得配置域名权限 */
}
@font-face {
  font-family: "EFM";  /* 这里的字体名称是自定义的 */
  src: url("https://img.thebeastshop.com/app/5.0/fonts/EuclidFlexMedium.ttf") format('opentype'); /* 服务器上ttf文件的路径，记得配置域名权限 */
}
@font-face {
  font-family: "EUCS";  /* 这里的字体名称是自定义的 */
  src: url("https://img.thebeastshop.com/app/5.0/fonts/EuphemiaCAS.ttc") format('opentype'); /* 服务器上ttf文件的路径，记得配置域名权限 */
}

.newn-tag-shoudan
  position relative
  display inline-block
  top rem(0)
  width rem(40)
  height rem(17)
  margin-left rem(7)
  font-size rem(10)
  font-weight 600
  line-height rem(17)
  // border-radius rem(2)
  border solid 0.7px #C44747
  text-align center
  color #C44747
.stats-tag-empty
  position relative
  width rem(30)
  height rem(17)
  margin-left 0
  margin-top rem(8)
  border solid 0.8px #9A9A9A
  font-size rem(10)
  span
    position absolute
    width 100%
    text-align center
    top 50%
    left 50%
    transform translate(-50%, -50%)
    color #9A9A9A
    font-size rem(10)
    font-weight 600
.dynamic-product-simple
  position relative
  // left rem(-1)
  width rem(187.5)
  flex 0 0 rem(187.5)
  // width rem(187.5)
  box-sizing border-box
  font-size rem(13)
  padding-bottom rem(16)
  // border solid 0.69px #f2f2f2
  background #F1F2F4
  overflow hidden 
  &.scene-wrap
    .scene-img
      position absolute
      top 0
      left 0
      right 0
      bottom 0
      img
        width 100%
        height 100%
        object-fit cover
  .line-btm
    position absolute
    bottom 0
    left 0
    width 100%
    height rem(1)
    background #fff
  .line-lft
    position absolute
    top 0
    bottom 0
    left 0
    width rem(1)
    height 100%
    background #fff
  .line-rt
    position absolute
    top 0
    bottom 0
    right 0
    width rem(1)
    height 100%
    background #fff
  &.left
    border-left none
    .line-lft
      display none
  &.right 
    border-right none
  &.no-top-border
    border-top none
    // border-left none
  &.big
    // position relative
    // flex 0 0 rem(375)
    .product-image
      // height rem(392)
  &.scene
    padding-bottom rem(0)
    .product-item-wrap
      height 100%
    image
      width 100%
      height 100%
    video
      width 100%
      height 100%
  .product-image
    position relative
    width 100%
    height rem(204)
    // margin-bottom rem(2)
    overflow hidden
    text-align center
    image
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      width 100%
      height 100%
      background-position 0 50%
      background-image url(//img.thebeastshop.com/app/5.0/images/default-list.png)
      background-repeat no-repeat
      background-size 100%
      
    .foretell-box
      position absolute
      top rem(12)
      right rem(12)
      width rem(32)
      height rem(32)
      box-sizing border-box
      border rem(1.5) solid #5C7D82
      background rgba(218, 229, 231, .95) none repeat scroll !important
      .foretell
        position relative
        width 100%
        top 50%
        transform translateY(-50%)
        font-size rem(11)
        line-height rem(12)
        color #5C7D82
        font-weight bold
        text-align center
    .activity-desc
      width 100%
      height rem(24)
      // line-height rem(17)
      padding 0 rem(5) rem(5)
      box-sizing border-box
      position absolute
      left 0
      bottom 0
      .desc
        display inline-block
        max-width 100%
        // height 100%
        line-height rem(19)
        padding 0 rem(6)
        background #f2f2f2 none repeat scroll !important
        opacity 0.95
        box-sizing border-box
        color #537371
        font-size rem(10)
        font-weight bold
        overflow hidden
        text-overflow ellipsis
        white-space wrap
    .stats-tag
      position absolute
      top rem(8)
      right rem(8)
      padding 0 rem(5)
      // width rem(32)
      height rem(18)
      font-size rem(10)
      letter-spacing rem(1)
      font-weight normal
      text-align center
      // box-sizing border-box
      &.large
        width rem(54)
    .img-soldout
      width rem(32)
      height rem(18)
      background-image none
      box-shadow none
      text
        width 100%
        padding rem(2) 0
        text-align center
        white-space nowrap
        line-height 1
        color #fff
    .corner-boxs
      position absolute
      top 0
      right 0
      left 0
      bottom 0
      overflow hidden
      .corner-label
        width rem(36)
        height rem(36)
        // margin-top rem(20)
        // margin-right rem(-26)
        // transform rotate(45deg)
        float right
  .product-infos
    text-align center
    color #000
    overflow hidden
  .summary
    line-height rem(14)
    ellipsis()
    width 100%
    font-size rem(10)
    line-height rem(14)
    margin-bottom rem(7)
    // font-weight 600
    color #838383
    &.normal
      font-size rem(11)
      font-weight 600
      color #C44747
      margin-bottom rem(6)
    &.hidden
      visibility hidden
  .name, .brand-name
    // ellipsis()
    text-align center
    margin 0 auto
    width rem(147)
    font-size rem(12)
    line-height rem(14.5)
    font-weight 600
    min-height rem(14)
    max-height rem(28)
    color #0C0C0C
    overflow hidden
  .tag
    ellipsis()
    margin-top rem(5)
    font-weight normal
    font-size rem(10)
    line-height rem(14)
    text-align center
    color #838383
  .prices
    font-size rem(11)
    font-family 'ECBM'
    margin rem(3) auto 0
    &.rush-color
      .discount-price
        color #C44747!important
    .price
      display inline-block
      vertical-align top
    &.newn
      .discount-price
        color #C44747
        .newn-tag
          position relative
          display inline-block
          top rem(-1)
          // margin-right rem(5)
          font-size rem(9)
          // font-weight 700
          line-height rem(13)
          border-radius rem(2)
          color #C44747
    .discount-price
      font-size rem(11)
      // font-weight 700
      color #000
    .decimal
      font-size rem(11)
    .symbol
      font-family auto
      margin-right rem(3)
    .raw-price
      position relative
      top rem(0)
      color #C9C9C9
      font-size rem(11)
      margin-left rem(3)
      text-decoration line-through
    .tags-wrap
      margin-left rem(10)
      clearfix()
      .label
        position relative
        float right
        // width rem(40)
        height rem(15)
        // line-height rem(15)
        margin-left rem(5)
        font-size rem(9)
        border solid 1px #9A9A9A
        color #9A9A9A
        text-align center
        padding 0 rem(2)
        box-sizing border-box
      .price-tag
        width rem(15)
        height rem(15)
        margin-right rem(2)
        image
          width 100%
          height 100%
      .panic-tag
        padding rem(3) rem(2)
        background #C44747
        color #fff
        font-size rem(9)
        line-height rem(9)
        font-weight bolder
  .stock-warn
    line-height rem(17)
    font-weight 600
    font-size rem(12)
    color #DD4F14
  .refund-wrap
    margin rem(8) auto 0
    text-align center
  .refund-box
    margin-top rem(4)
  .refund
    display inline-block
    padding rem(0.8) rem(5)
    box-sizing border-box
    border solid 0.8px #C44747
    font-size rem(10)
    font-weight normal
    color #C44747
</style>



// WEBPACK FOOTER //
// index.vue?2e6c4396